/** The app icon, for in-app headings (sign-in, header bar, side rail). */
export function AppMark({ size, className }: { size: number; className?: string }) {
  return (
    <img
      className={'app-mark' + (className ? ' ' + className : '')}
      src={import.meta.env.BASE_URL + 'icons/icon-192x192.png'}
      alt=""
      width={size}
      height={size}
      style={{ borderRadius: Math.round(size * 0.23) }}
    />
  );
}
